/**
 * @generated SignedSource<<c77bde5aadfee517025c6791f2ee54bb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "ContractBillingGroups_BillingGroups",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BillingGroupIdentifier",
      "kind": "LinkedField",
      "name": "identifiers",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "IdentifierType",
          "kind": "LinkedField",
          "name": "identifierType",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "code",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BillingGroup",
  "abstractKey": null
};

node.hash = "0f6bd9a4e6163c15125002950f03e023";

export default node;
